export default {"dialog":"SsuMv","content":"NNipG","textContainer":"_7JKp2","--isOpen":"_4pHJ2","--hasImage":"fIbqY"};